import { Check, } from "@mui/icons-material";
import { Card, Grid, Typography } from "@mui/material";
import { useEffect, } from "react";
import { useReducer, useState } from "react";
import useFetch from "../hooks/useFetch";
import Form, { FormActions } from "../components/Form";
import DataTable from "../components/DataTable";
import { toDateTimeFormat, toDateTimeFormat1, toIsoFormat } from "../utils";
import { DETAILS_APIS, MASTER_DATA_APIS, } from "../common/apis";
import FormFooter from "../components/FormFooter";
import moment from "moment";
import AppDialog from "../components/AppDialog";
import appResources from "../app-resources/en/Resources.json";
import ConfirmModal from "../components/ConfirmModal";

export default function EditTray({ eventFilter,setOpenTray }) {

  const [data, dispatch] = useReducer(SearchFilterReducer, SearchFilterDefaults);
  const { get, post } = useFetch();
  const [rerunsByDateData, setRerunsByDateData] = useState([]);
  const [trayOverview, setTrayOverview] = useState();
  const [laboratories, setLaboratories] = useState();
  const [alertObj, setAlertObj] = useState({ open: false });

  //Call api for user dropdown data
  useEffect(() => {
    (async function () {
      try {
        const response = await get(`${MASTER_DATA_APIS.GET_BY_TYPES}?types=Laboratories`);
        setLaboratories(response.Laboratories || []);
      }
      catch (err) {
        setLaboratories([]);
        console.log("error" - err)
      }
    })()

    if (eventFilter === undefined) {
      let lData = localStorage.getItem("edit-tray");
      if (lData !== null) {
        lData = JSON.parse(lData);
        const trayDate = lData?.SampleNumber.toString()?.slice(0, 8);
        const trayNo = lData?.SampleNumber.toString()?.slice(9, -2);
        const trayLabId = lData?.SampleNumber.toString()?.slice(8, 9);
        loadData(trayLabId, trayNo, trayDate);
      }
    }
    else {
      const trayDate = eventFilter?.SampleNumber.toString()?.slice(0, 8);
      const trayNo = eventFilter?.SampleNumber.toString()?.slice(9, -2);
      const trayLabId = eventFilter?.SampleNumber.toString()?.slice(8, 9);
      loadData(trayLabId, trayNo, trayDate);
    }
  }, []);

  async function loadData(lab, tray, date) {
    let responseTrayData = await get(`${DETAILS_APIS.TRAY_OVERVIEW}?laboratoryId=${lab}&tray=${tray}&trayDate=${date}`);
    if (responseTrayData) {
      if (responseTrayData.trayOverview.length > 0) {
        setTrayOverview(responseTrayData.trayOverview[0]);
        setRerunsByDateData(responseTrayData.rerunsByDate);
        dispatch({
          payload: {
            ...responseTrayData.trayOverview[0],
            key: Date.now(),
          },
          type: FormActions.LOAD_DATA,
        });
      } else {
        setRerunsByDateData([]);
        setTrayOverview();
      }
    }
  }

  //call api for search audit data
  async function saveClick() {
    await post(DETAILS_APIS.EDIT_TRAY, {
      ...data,
      LaboratoryId: data?.LaboratoryId,
      Tray: data?.Tray,
      TrayDate: data?.TrayDate,
      Delivered: data?.ReceivedMinimum,
      IsTrainingSample: data?.IsTrainingSample || false,
      OwnerLaboratoryId: data?.OwnerLaboratoryId,
      TrayLabel: data?.TrayLabel,
    });
    const trayDate = eventFilter?.SampleNumber.toString()?.slice(0, 8);
    const trayNo = eventFilter?.SampleNumber.toString()?.slice(9, -2);
    const trayLabId = eventFilter?.SampleNumber.toString()?.slice(8, 9);

    await loadData(trayLabId, trayNo, trayDate);
    setOpenTray && setOpenTray(false);
  }

  const tblOptions = {
    columns: GetColumns(),
    dataSource: (rerunsByDateData || [])?.map((item, i) => { return { ...item, keyProp: i } }),
    rowIdProperty: "keyProp",
    isDisableColumnFilter: true,
    sx: { height: 500 },
  };

  const handleCloseButton = () => {
    localStorage.removeItem("edit-tray");
  }

  useEffect(function () {
    window.addEventListener("beforeunload", handleCloseButton);
    return function () {
      window.removeEventListener("beforeunload", handleCloseButton);
    };
  });

  function training() {
    setAlertObj({
      selectedFunction: alertTraining,
      title: "Training Tray",
      open: true,
      buttonText: "Yes",
      message: appResources.CHANGING_TRAY_TRAINING
    });
  }

  async function alertTraining() {
    setAlertObj({ open: false });
  }

  useEffect(() => {
    if (data.IsTrainingSample && !trayOverview?.IsTrainingSample) {
      training();
    }
  }, [data.IsTrainingSample]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ p: 1 }}>
            <Form
              sections={GetFormSections(laboratories, trayOverview, data)}
              data={data}
              dispatch={dispatch}
              key={data?.key}
            />
            <FormFooter buttons={GetFormButtons(saveClick,)} />
          </Card>
        </Grid>

        <Grid item xs={12}>
          <DataTable {...tblOptions} />
        </Grid>
      </Grid>
            <AppDialog
              open={alertObj?.open}
              title={alertObj?.title}
              maxWidth="md"
              handleClose={() => {
                setAlertObj({ open: false });
              }}
            >
              <ConfirmModal
                handleClose={() => {
                  setAlertObj({ open: false });
                  dispatch({ type: FormActions.INPUT_CHANGED, payload: { name: "IsTrainingSample", value: false } })
                }}
                alertAction={alertObj?.selectedFunction}
                message={alertObj?.message}
                buttonText={alertObj?.buttonText}
                buttonText2={"Cancel"} />
            </AppDialog>
    </>
  );
}

function GetColumns() {
  return [
    {
      headerName: "Type",
      field: "Type",
      minWidth: 120,
    },
    {
      headerName: "SampleNumber",
      field: "SampleNumber",
      minWidth: 120,
    },
    {
      headerName: "Sample Count",
      field: "SampleCount",
      minWidth: 100,
    },
    {
      headerName: "Send Back",
      field: "SentBack",
      valueFormatter: ({ value }) => toDateTimeFormat(value),
      minWidth: 170,
    },

    {
      headerName: "Send By",
      field: "SentBy",
      minWidth: 200,
    },
    {
      headerName: "Reason",
      field: "Reason",
      minWidth: 200,
      flex: 1,
    },
  ];
}

function GetFormSections(laboratories, trayOverview, data) {
  return [
    {
      fields: [
        {
          xsCol: 12,
          group: [
            {
              xsCol: 12,
              component: function () {
                return (
                  <Typography >
                    {/* Tray {trayOverview?.Tray} on {trayOverview?.TrayDateDate} Laboratory  */}
                  </Typography>
                );
              },
            },
          ],
        },

        {
          name: "TrayLabel",
          label: "Tray Label",
          xsCol: 1,
        },
        {
          name: "LaboratoryId",
          label: "Owner",
          type: "dropdown",
          xsCol: 2,
          required: true,
          selectOptions: (laboratories || [])
            ?.filter((x) => x?.LaboratoryId !== 0)
            ?.map((x) => ({
              value: x.LaboratoryId,
              text: x.Laboratory,
            })),
        },

        {
          name: "IsTrainingSample",
          label: "Training",
          xsCol: 1,
          type: "switch",
        },
        {
          name: "IsDelivered",
          label: "Delivered",
          xsCol: 1,
          type: "switch",
        },
        {
          name: "ReceivedMinimum",
          label: "Use Delivered",
          xsCol: 2,
          type: "datetime",
          disabled: !data?.IsDelivered,
          disableFuture: true,
        },
        {
          xsCol: 2,
          alignSelf: "end",
          component: function ({ data }) {
            return (
              <Typography >
                The earliest Tray Date is{" "}
                {toDateTimeFormat1(trayOverview?.ReceivedMinimum)}
              </Typography>
            );
          },
        },
        {
          name: "Re-Approve",
          label: "Re-Approve",
          type: "switch",
          xsCol: 1,
          alignSelf: "end",
        },
        {
          xsCol: 2,
          alignSelf: "end",
          component: function ({ data }) {
            return (
              <Typography >
                Tray. where already released
              </Typography>
            );
          },
        },

        {
          xsCol: 12,
          group: [
            {
              xsCol: 2,
              alignSelf: "end",
              component: function () {
                return (
                  <Typography >
                    Sample Count {trayOverview?.SampleCount}
                  </Typography>
                );
              },
            },
            {
              xsCol: 2,
              alignSelf: "end",
              component: function () {
                return (
                  <Typography >
                    New Version Count {trayOverview?.NewVersionCount}
                  </Typography>
                );
              },
            },
            {
              xsCol: 6,
              alignSelf: "end",
              component: function () {
                return (
                  <Typography >
                    On Hold Count {trayOverview?.HoldCount}
                  </Typography>
                );
              },
            },
          ],
        },
      ],
    },
  ];
}

function SearchFilterReducer(state, action) {
  if (action.type === FormActions.INPUT_CHANGED) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  if (action.type === FormActions.LOAD_DATA) {
    return action.payload;
  }
  return state;
}

const SearchFilterDefaults = {
  ReceivedMinimum: toIsoFormat(new moment()),
  LaboratoryId: 1,
};

const GetFormButtons = (saveClick,) => [
  {
    label: "Save",
    onClick: saveClick,
    startIcon: <Check />,
  },
];
